import { notificationDtoToNotification } from '../../mappers/notification';
import { api } from './api';
export const NotificationApi = api.injectEndpoints({
    endpoints: (builder) => ({
        notificationList: builder.query({
            query: () => ({
                url: 'api/NotificacaoPDC',
            }),
            transformResponse: (response) => notificationDtoToNotification(response),
        }),
        viewNotification: builder.mutation({
            query: ({ type, id }) => ({
                method: 'post',
                url: `api/NotificacaoPDC/visualizar/${type}/${id}`,
            }),
        }),
        clearNotifications: builder.mutation({
            query: () => ({
                method: 'post',
                url: 'api/NotificacaoPDC/visualizar/todos',
            }),
        }),
    }),
});
export const { useNotificationListQuery, useViewNotificationMutation, useClearNotificationsMutation, } = NotificationApi;
